import {IOption, ISelectField} from "~/cabinet/vue/interface/form/elements/Interfaces";
import {CLIENT_DATA_TYPE_SELECT} from "~/chat/ts/data/IClient";
import Random from "~/ts/library/Random";

export function numberToStringWithZero(i: number): string {
    return i < 10 ? `0${i}` : i.toString();
}


export function createTimeSelect(maxValue: number): ISelectField {
    let options: IOption[] = [];
    for (let i = 0; i <= maxValue; i++) {
        let value = numberToStringWithZero(i);
        options.push({
            value,
            descr: value
        });
    }
    return {
        type: CLIENT_DATA_TYPE_SELECT,
        options,
        name: Random.uid(10),
        optgroup: []
    };
}
